export const topicSectionDividerNcssNode = {
  ncss: {
    my: '1rem',
    color: 'inherit',
    backgroundColor: 'dividerBg',
    border: 0,
    opacity: '0.25',
    h: '1px',
  },
}
